import dashboardReducer from "./dashboard/const";
import dashboardStatsReducer from "./dashboard/stats";
import surveillanceDashboardReducer from "./dashboard/surveillanceConst";
import surveillanceDashboardStatsReducer from "./dashboard/surveillanceStats";

import scopeLevelReducer from "./scopeLevel/const";

import mspUserManagementReducer from "./userManagement/msp/const";
import orgUserManagementReducer from "./userManagement/org/const";
import onPremUserManagemantRuducer from "./userManagement/on-prem/const";

import profile from "./profile/const";

import meReducer from "./me/const";

import topologyReducer from "./topology/const";

import devicesReducer from "./devices/const";
import devicesDrawerContentReducer from "./devices/drawerContent/const";
import firmwareManagementsReducer from "./firmwareManagements/const";
import addDeviceInformHostReducer from "./devices/addDevice/informHost";
import addDeviceSitesReducer from "./devices/addDevice/sites";
import addDeviceInventoryDeviceAccountReducer from "./devices/addDevice/inventoryDeviceAccount";
import addDeviceDeviceAccountReducer from "./devices/addDevice/deviceAccounts";
import addDeviceOrgDevicesReducer from "./devices/addDevice/orgDevices";
import addDeviceSiteDevicesReducer from "./devices/addDevice/siteDevices";
import addDeviceDiscoveredOrgDevicesReducer from "./devices/addDevice/discoveredOrgDevices";
import addDeviceDiscoveredSiteDevicesReducer from "./devices/addDevice/discoveredSiteDevices";
import addDeviceStopDiscoveryOrgDevices from "./devices/addDevice/stopDiscoveryOrgDevices";
import addDeviceStopDiscoverySiteDevices from "./devices/addDevice/stopDiscoverySiteDevices";
import addDeviceAuthenticatedOrgDevices from "./devices/addDevice/authenticatedOrgDevices";
import addDeviceAuthenticatedSiteDevices from "./devices/addDevice/authenticatedSiteDevices";
import addDeviceIpSettingOrgDevices from "./devices/addDevice/ipSettingOrgDevices";
import addDeviceIpSettingSiteDevices from "./devices/addDevice/ipSettingSiteDevices";
import addDeviceAdoptOrgDevices from "./devices/addDevice/adoptOrgDevices";
import addDeviceAdoptSiteDevices from "./devices/addDevice/adoptSiteDevices";
import addDevicePreRegisterOrgDevices from "./devices/addDevice/preRegisterDevices";
import addDeviceSurveillanceDiscoveredDevices from "./devices/addDevice/surveillanceDiscoveredDevices";
import addDeviceSurveillanceStopDiscovery from "./devices/addDevice/surveillanceStopDiscovery";
import addDeviceSurveillanceAuthenticatedDevices from "./devices/addDevice/surveillanceAuthenticatedDevices";
import addDeviceSurveillanceAdoptDevices from "./devices/addDevice/surveillanceAdoptDevices";

import eventsReducer from "./events/const";

import clientsReducer from "./clients/const";
import selectedClientReducer from "./clients/selectedClient";
import clientStatisticsSlice from "./clients/statistics";
import wirelessSSIDReducer from "./wireless/ssid";
import wirelessRadioReducer from "./wireless/radio";
import wiredRuducer from "./wired/const";
import portTagsReducer from "./wired/portTags";
import wiredQosReducer from "./wired/qos";
import wiredIpv4AclReducer from "./wired/ipv4Acl";
import wiredVoiceVlanReducer from "./wired/voiceVlan";
import wiredConfigProvisionings from "./wired/configProvisionings";
import defaultConfigProvisionings from "./wired/defaultConfigProvisionings";
import captivePortalReducer from "./captivePortal/const";
import profilesPortsReducer from "./profiles/ports/const";
import profilesMacAddressReducer from "./profiles/macAddress/const";
import profilesIpAddressReducer from "./profiles/ipAddress/const";
import profilesUserAccountReducer from "./profiles/userAccount/const";
import profilesRadiusServerReducer from "./profiles/radiusServer/const";
import profilesScheduleReducer from "./profiles/schedule/const";
import profilesLdapServerReducer from "./profiles/ldapServer/const";
import settingNotificationsReducer from "./settingNotifications/const";
import mspGeneralReducer from "./settingsGeneral/msp/const";
import orgGeneralReducer from "./settingsGeneral/org/const";
import siteGeneralReducer from "./settingsGeneral/site/const";
import deviceModelList from "./system/deviceModelList";
import scheduleRebootReducer from "./system/scheduleReboot";

import ainsightOverviewReducer from "./ainsight/overview/const";
import ainsightServiceExperienceReducer from "./ainsight/serviceExperience/const";
import ainsightOperationsReducer from "./ainsight/operations/const";
import ainsightRoamReducer from './ainsight/roam/const';
import ainsightWirelessCoverageReducer from './ainsight/wirelessCoverage/const';
import ainsightLinkIntegrityReducer from './ainsight/linkIntegrity/const';
import summaryReportAInsightReducer from "./summaryReport/ainsight";
import summaryReportLogsReducer from "./summaryReport/logs";
import summaryReportListReducer from "./summaryReport/reports";
import summaryReportTopologyReducer from "./summaryReport/topology";
import summaryReportOverviewReducer from "./summaryReport/overview";
import summaryReportClientsReducer from "./summaryReport/clients";
import summaryReportDevicesReducer from "./summaryReport/devices";
import licenseReducer from "./license/const";
import chatbotReducer from "./chatbot/const";
import liveViewsReducer from "./liveViews/const";

const bogusReducers = {
  dashboard: dashboardReducer,
  dashboardStats: dashboardStatsReducer,
  surveillanceDashboard: surveillanceDashboardReducer,
  surveillanceDashboardStats: surveillanceDashboardStatsReducer,
  scopeLevel: scopeLevelReducer,
  mspUserManagement: mspUserManagementReducer,
  orgUserManagement: orgUserManagementReducer,
  onPremUserManagement: onPremUserManagemantRuducer,
  profile: profile,
  me: meReducer,
  topology: topologyReducer,
  devices: devicesReducer,
  devicesDrawerContent: devicesDrawerContentReducer,
  firmwareManagements: firmwareManagementsReducer,
  addDeviceInformHost: addDeviceInformHostReducer,
  addDeviceSites: addDeviceSitesReducer,
  addDeviceInventoryDeviceAccount: addDeviceInventoryDeviceAccountReducer,
  addDeviceDeviceAccount: addDeviceDeviceAccountReducer,
  addDeviceOrgDevices: addDeviceOrgDevicesReducer,
  addDeviceSiteDevices: addDeviceSiteDevicesReducer,
  addDeviceDiscoveredOrgDevices: addDeviceDiscoveredOrgDevicesReducer,
  addDeviceDiscoveredSiteDevices: addDeviceDiscoveredSiteDevicesReducer,
  addDeviceStopDiscoveryOrgDevices: addDeviceStopDiscoveryOrgDevices,
  addDeviceStopDiscoverySiteDevices: addDeviceStopDiscoverySiteDevices,
  addDeviceAuthenticatedOrgDevices: addDeviceAuthenticatedOrgDevices,
  addDeviceAuthenticatedSiteDevices: addDeviceAuthenticatedSiteDevices,
  addDeviceIpSettingOrgDevices: addDeviceIpSettingOrgDevices,
  addDeviceIpSettingSiteDevices: addDeviceIpSettingSiteDevices,
  addDeviceAdoptOrgDevices: addDeviceAdoptOrgDevices,
  addDeviceAdoptSiteDevices: addDeviceAdoptSiteDevices,
  addDevicePreRegisterOrgDevices: addDevicePreRegisterOrgDevices,
  addDeviceSurveillanceDiscoveredDevices: addDeviceSurveillanceDiscoveredDevices,
  addDeviceSurveillanceStopDiscovery: addDeviceSurveillanceStopDiscovery,
  addDeviceSurveillanceAuthenticatedDevices: addDeviceSurveillanceAuthenticatedDevices,
  addDeviceSurveillanceAdoptDevices: addDeviceSurveillanceAdoptDevices,
  events: eventsReducer,
  clients: clientsReducer,
  selectedClient: selectedClientReducer,
  clientStatistics: clientStatisticsSlice,
  wiredVoiceVlan: wiredVoiceVlanReducer,
  wiredConfigProvisionings: wiredConfigProvisionings,
  defaultConfigProvisionings: defaultConfigProvisionings,
  wireless: wirelessSSIDReducer,
  wirelessRadio: wirelessRadioReducer,
  wired: wiredRuducer,
  portTags: portTagsReducer,
  wiredQos: wiredQosReducer,
  wiredIpv4Acl: wiredIpv4AclReducer,
  captivePortal: captivePortalReducer,
  profilesPorts: profilesPortsReducer,
  profilesMacAddress: profilesMacAddressReducer,
  profilesIpAddress: profilesIpAddressReducer,
  profilesUserAccount: profilesUserAccountReducer,
  profilesRadiusServer: profilesRadiusServerReducer,
  profilesSchedule: profilesScheduleReducer,
  profilesLdapServer: profilesLdapServerReducer,
  settingNotifications: settingNotificationsReducer,
  mspGeneral: mspGeneralReducer,
  orgGeneral: orgGeneralReducer,
  siteGeneral: siteGeneralReducer,
  deviceModelList: deviceModelList,
  ainsightOverview: ainsightOverviewReducer,
  ainsightServiceExperience: ainsightServiceExperienceReducer,
  ainsightOperations: ainsightOperationsReducer,
  ainsightRoam: ainsightRoamReducer,
  ainsightWirelessCoverage: ainsightWirelessCoverageReducer,
  ainsightLinkIntegrity: ainsightLinkIntegrityReducer,
  summaryReportAInsight: summaryReportAInsightReducer,
  summaryReportLogs: summaryReportLogsReducer,
  summaryReportList: summaryReportListReducer,
  summaryReportTopology: summaryReportTopologyReducer,
  summaryReportOverview: summaryReportOverviewReducer,
  summaryReportClients: summaryReportClientsReducer,
  summaryReportDevices: summaryReportDevicesReducer,
  license: licenseReducer,
  chatbot: chatbotReducer,
  scheduleReboot: scheduleRebootReducer,
  liveViews: liveViewsReducer,
};

export default bogusReducers;
